import { render, staticRenderFns } from "./ContentCollections.vue?vue&type=template&id=44633c02"
import script from "./ContentCollections.vue?vue&type=script&lang=js"
export * from "./ContentCollections.vue?vue&type=script&lang=js"
import style0 from "./ContentCollections.vue?vue&type=style&index=0&id=44633c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports